<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <ICDForm :icd="extension" :edit="true" :extension="true" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import ICDForm from "@/components/icd/ICDForm.vue";
import axios from "axios";

export default {
  name: "EditExtension",
  components: {
    NavBar,
    ICDForm
  },
  data: () => ({
    loading: false,
    extension: {code: '...'}
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "ICD-11",
					disabled: false,
          link: true,
          to: "/admin/dashboard/icd"
        },
        {
					text: this.extension.code,
					disabled: true,
					link: true
				}
			];
		}
  },
  created() {
    const extensionId = this.$route.params.eid;
    this.loading = true;
    axios
      .get("/extension-codes/" + extensionId, {params: {admin: true}})
      .then(response => {
        console.log(response.data);
        this.extension = response.data.extension;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        this.loading = false;
      });
  }
}
</script>